import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from './defaultIconStyles.css';

type Props = IconProps & React.SVGProps<SVGSVGElement>;
export const IconAttach = ({
    width = '15',
    height = '16',
    className,
    ...rest
}: Props) => (
    <svg
        className={classnames(css.main, className)}
        width={width}
        height={height}
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.475 4.19C5.548 3.117 7.291 3.117 8.364 4.19C9.437 5.263 9.437 7.006 8.364 8.079L5.56 10.884C5.17 11.274 4.536 11.274 4.146 10.884C3.755 10.493 3.755 9.86 4.146 9.469L6.267 7.348L6.949 6.666C7.241 6.374 7.241 5.898 6.949 5.606C6.656 5.313 6.181 5.313 5.888 5.606L2.731 8.762C1.756 9.738 1.756 11.322 2.731 12.298C3.707 13.273 5.291 13.273 6.267 12.298L11.328 7.237C12.303 6.261 12.303 4.677 11.328 3.701C10.694 3.067 9.802 2.845 8.988 3.036C8.855 3.069 8.714 3.048 8.597 2.976C8.437 2.885 8.274 2.801 8.106 2.728C7.63 2.521 7.119 2.412 6.606 2.401C6.549 2.401 6.498 2.366 6.477 2.312C6.456 2.259 6.471 2.199 6.513 2.16C6.548 2.127 6.578 2.099 6.596 2.083C8.363 0.534999 11.056 0.602999 12.741 2.288C14.497 4.044 14.497 6.896 12.741 8.652L7.681 13.712C5.925 15.468 3.073 15.468 1.317 13.712C-0.439 11.956 -0.439 9.104 1.317 7.348L4.475 4.19Z"
            className={classnames(css.colored)}
        />
    </svg>
);

export default IconAttach;
